import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaCalendarAlt, FaMapMarkerAlt, FaClock, FaFilter, FaSearch } from "react-icons/fa";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../components/Header";
import Footer from "../components/Footer";

// Données des événements (à remplacer par une API)
const EventsData = [
  {
    id: 1,
    title: "Webinaire: Préparer sa clôture comptable 2025",
    description: "Découvrez les meilleures pratiques pour une clôture comptable réussie avec nos experts-comptables.",
    date: "15 Mai 2025",
    time: "14:30 - 16:00",
    location: "En ligne",
    type: "Webinaire",
    image: "/assets/images/webinar-image.jpg",
    featured: true,
    registrationLink: "#inscription-webinaire",
    speakers: [
      { name: "Marie Laurent", role: "Expert-comptable", image: "/assets/images/speaker1.jpg" }
    ]
  },
  {
    id: 2,
    title: "Formation: Optimisation fiscale pour PME",
    description: "Une journée complète pour comprendre et mettre en place une stratégie d'optimisation fiscale adaptée à votre PME.",
    date: "22 Mai 2025",
    time: "09:00 - 17:00",
    location: "CINEF-EC Paris",
    type: "Formation",
    image: "/assets/images/formation-image.jpg",
    featured: true,
    registrationLink: "#inscription-formation",
    speakers: [
      { name: "Jean Dupont", role: "Fiscaliste", image: "/assets/images/speaker2.jpg" },
      { name: "Sophie Benoit", role: "Expert-comptable", image: "/assets/images/speaker3.jpg" }
    ]
  },
  {
    id: 3,
    title: "Conférence: Impact des réformes fiscales 2025",
    description: "Analyse approfondie des nouvelles mesures fiscales et leurs conséquences pour les entreprises.",
    date: "5 Juin 2025",
    time: "10:00 - 12:30",
    location: "Hôtel Mercure, Lyon",
    type: "Conférence",
    image: "/assets/images/conference-image.jpg",
    featured: false,
    registrationLink: "#inscription-conference",
    speakers: [
      { name: "Thomas Martin", role: "Directeur fiscal", image: "/assets/images/speaker4.jpg" }
    ]
  },
  {
    id: 4,
    title: "Atelier pratique: Comptabilité pour auto-entrepreneurs",
    description: "Maîtrisez les bases de la comptabilité adaptée aux auto-entrepreneurs et micro-entreprises.",
    date: "12 Juin 2025",
    time: "14:00 - 17:00",
    location: "CINEF-EC Lyon",
    type: "Atelier",
    image: "/assets/images/atelier-image.jpg",
    featured: false,
    registrationLink: "#inscription-atelier",
    speakers: [
      { name: "Claire Rousseau", role: "Consultante", image: "/assets/images/speaker5.jpg" }
    ]
  },
  {
    id: 5,
    title: "Table ronde: L'avenir de la profession comptable",
    description: "Échanges entre professionnels sur les évolutions de la profession face à la digitalisation.",
    date: "18 Juin 2025",
    time: "18:30 - 20:30",
    location: "Auditorium CINEF-EC, Paris",
    type: "Table ronde",
    image: "/assets/images/table-ronde-image.jpg",
    featured: false,
    registrationLink: "#inscription-table-ronde",
    speakers: [
      { name: "Philippe Girard", role: "Président CINEF-EC", image: "/assets/images/speaker6.jpg" },
      { name: "Émilie Durand", role: "Consultante digital", image: "/assets/images/speaker7.jpg" }
    ]
  },
  {
    id: 6,
    title: "Formation: Maîtriser les normes IFRS 2025",
    description: "Formation approfondie sur les dernières modifications des normes IFRS et leur application pratique.",
    date: "25 Juin 2025",
    time: "09:00 - 17:00",
    location: "CINEF-EC Paris",
    type: "Formation",
    image: "/assets/images/formation-ifrs-image.jpg",
    featured: false,
    registrationLink: "#inscription-formation-ifrs",
    speakers: [
      { name: "Antoine Mercier", role: "Expert IFRS", image: "/assets/images/speaker8.jpg" }
    ]
  },
  {
    id: 7,
    title: "Webinaire: Déclaration sociale des indépendants",
    description: "Guide complet pour vous aider à remplir correctement votre DSI et éviter les erreurs courantes.",
    date: "2 Juillet 2025",
    time: "11:00 - 12:30",
    location: "En ligne",
    type: "Webinaire",
    image: "/assets/images/webinar-dsi-image.jpg",
    featured: false,
    registrationLink: "#inscription-webinaire-dsi",
    speakers: [
      { name: "Marie Laurent", role: "Expert-comptable", image: "/assets/images/speaker1.jpg" }
    ]
  },
  {
    id: 8,
    title: "Conférence: RSE et reporting extra-financier",
    description: "Comprendre les nouvelles obligations de reporting extra-financier et leurs enjeux pour votre entreprise.",
    date: "10 Juillet 2025",
    time: "14:00 - 17:00",
    location: "Espace Conférence, Marseille",
    type: "Conférence",
    image: "/assets/images/conference-rse-image.jpg",
    featured: false,
    registrationLink: "#inscription-conference-rse",
    speakers: [
      { name: "Claire Rousseau", role: "Consultante RSE", image: "/assets/images/speaker5.jpg" }
    ]
  }
];

// Types d'événements pour le filtre
const EventTypes = [
  "Tous", "Webinaire", "Formation", "Conférence", "Atelier", "Table ronde"
];

// Mois pour le filtre calendrier
const Months = [
  "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre"
];

const Evenements = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedType, setSelectedType] = useState("Tous");
  const [selectedMonth, setSelectedMonth] = useState("Tous");
  const [filteredEvents, setFilteredEvents] = useState(EventsData);
  const [featuredEvents, setFeaturedEvents] = useState([]);
  const [emailSubscription, setEmailSubscription] = useState("");
  const [eventsToShow, setEventsToShow] = useState(4);
  const [showFilters, setShowFilters] = useState(false);

  useEffect(() => {
    // Animation des éléments au scroll
    const sections = document.querySelectorAll(".animate-on-scroll");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
          }
        });
      },
      { threshold: 0.2 }
    );

    sections.forEach((section) => {
      observer.observe(section);
    });

    // Filtrer les événements mis en avant
    setFeaturedEvents(EventsData.filter(event => event.featured));

    return () => {
      sections.forEach((section) => {
        observer.unobserve(section);
      });
    };
  }, []);

  useEffect(() => {
    // Filtrer les événements en fonction de la recherche, du type et du mois
    const filtered = EventsData.filter(event => {
      const matchesSearch = event.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        event.description.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesType = selectedType === "Tous" || event.type === selectedType;
      const matchesMonth = selectedMonth === "Tous" || event.date.includes(selectedMonth);
      return matchesSearch && matchesType && matchesMonth;
    });

    setFilteredEvents(filtered);
  }, [searchTerm, selectedType, selectedMonth]);

  const handleSubmitSubscription = (e) => {
    e.preventDefault();
    // Logique pour traiter l'inscription aux alertes événements
    alert(`Email ${emailSubscription} inscrit aux alertes événements avec succès!`);
    setEmailSubscription("");
  };

  const loadMoreEvents = () => {
    setEventsToShow(prev => prev + 4);
  };

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  return (
    <>
      <Header />

      {/* Hero Section avec animation */}
      <div className="events-hero-section">
        <div className="events-hero-content">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <motion.div
                  initial={{ opacity: 0, x: -50 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8 }}
                  className="events-hero-text"
                >
                  <h1 className="events-hero-title">
                    <span className="events-hero-subtitle">Restez informés</span>
                    <span className="events-main-title">Nos <span className="text-gradient">Événements</span></span>
                  </h1>
                  <p className="events-hero-desc">
                    Formations, webinaires, conférences... Rencontrez nos experts et développez vos compétences
                  </p>
                  <div className="events-counter">
                    <div className="counter-item">
                      <div className="counter-number">{filteredEvents.length}</div>
                      <div className="counter-label">Événements à venir</div>
                    </div>
                    <div className="counter-item">
                      <div className="counter-number">4</div>
                      <div className="counter-label">Villes</div>
                    </div>
                    <div className="counter-item">
                      <div className="counter-number">12</div>
                      <div className="counter-label">Experts</div>
                    </div>
                  </div>
                </motion.div>
              </div>
              <div className="col-lg-6">
                <motion.div
                  className="events-hero-image"
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 1 }}
                >
                  <div className="events-calendar">
                    <div className="calendar-header">
                      <div className="month-display">Mai 2025</div>
                    </div>
                    <div className="calendar-body">
                      <div className="week-days">
                        <div>L</div>
                        <div>M</div>
                        <div>M</div>
                        <div>J</div>
                        <div>V</div>
                        <div>S</div>
                        <div>D</div>
                      </div>
                      <div className="days-grid">
                        {Array.from({ length: 31 }, (_, i) => {
                          // Vérifier si le jour a un événement
                          const hasEvent = EventsData.some(event => {
                            const eventDay = parseInt(event.date.split(' ')[0]);
                            return eventDay === i + 1 && event.date.includes('Mai');
                          });

                          return (
                            <div
                              key={i}
                              className={`day-cell ${hasEvent ? 'has-event' : ''}`}
                            >
                              {i + 1}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <div className="calendar-footer">
                      <div className="legend">
                        <div className="legend-item">
                          <div className="legend-dot has-event"></div>
                          <span>Événement</span>
                        </div>
                        <div className="legend-item">
                          <div className="legend-dot"></div>
                          <span>Aucun événement</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
          
        </div>
      </div>

      {/* Section Événements à la Une */}
      <section className="featured-events-section">
        <div className="container">
          <motion.h2
            className="section-title"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="highlight">Événements à la Une</span>
          </motion.h2>

          <div className="row">
            {featuredEvents.map((event, index) => (
              <motion.div
                key={event.id}
                className="col-md-6 mb-5"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
              >
                <div className="featured-event-card">
                  <div className="featured-event-image">
                    <img
                      src="../assets/images/image19.png"
                      alt={event.title}
                      className="img-fluid"
                    />
                    <div className="event-type-badge">{event.type}</div>
                  </div>
                  <div className="featured-event-content">
                    <div className="event-meta">
                      <div className="event-date-time">
                        <FaCalendarAlt className="icon" /> {event.date} <span className="separator">|</span> <FaClock className="icon" /> {event.time}
                      </div>
                      <div className="event-location">
                        <FaMapMarkerAlt className="icon" /> {event.location}
                      </div>
                    </div>
                    <h3 className="event-title">{event.title}</h3>
                    <p className="event-description">{event.description}</p>

                    <div className="event-speakers">
                      {event.speakers.map((speaker, i) => (
                        <div key={i} className="event-speaker">
                          <div className="speaker-avatar">
                            <img src="../assets/images/image6.png" alt={speaker.name} />
                          </div>
                          <div className="speaker-info">
                            <div className="speaker-name">{speaker.name}</div>
                            <div className="speaker-role">{speaker.role}</div>
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className="event-actions">
                      <Link to={`/evenements/${event.id}`} className="btn-details">
                        Détails
                      </Link>
                      <a href={event.registrationLink} className="btn-register">
                        S'inscrire
                      </a>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Section Recherche et Filtres */}
      <section className="events-filter-section">
        <div className="container">
          <div className="search-filter-container">
            <div className="search-container">
              <FaSearch className="search-icon" />
              <input
                type="text"
                className="search-input"
                placeholder="Rechercher un événement..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <button className="toggle-filters-btn" onClick={toggleFilters}>
              <FaFilter className="mr-2" /> Filtres
            </button>
          </div>

          {showFilters && (
            <motion.div
              className="filters-container"
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              transition={{ duration: 0.3 }}
            >
              <div className="row">
                <div className="col-md-6">
                  <div className="filter-group">
                    <h4 className="filter-title">Type d'événement</h4>
                    <div className="filter-options">
                      {EventTypes.map((type, index) => (
                        <button
                          key={index}
                          className={`filter-option ${selectedType === type ? 'active' : ''}`}
                          onClick={() => setSelectedType(type)}
                        >
                          {type}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="filter-group">
                    <h4 className="filter-title">Mois</h4>
                    <div className="filter-options">
                      <button
                        className={`filter-option ${selectedMonth === 'Tous' ? 'active' : ''}`}
                        onClick={() => setSelectedMonth('Tous')}
                      >
                        Tous
                      </button>
                      {Months.map((month, index) => (
                        <button
                          key={index}
                          className={`filter-option ${selectedMonth === month ? 'active' : ''}`}
                          onClick={() => setSelectedMonth(month)}
                        >
                          {month}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          )}
        </div>
      </section>

      {/* Section Liste des Événements */}
      <section className="events-list-section">
        <div className="container">
          <div className="results-count mb-4">
            {filteredEvents.length} événement{filteredEvents.length > 1 ? 's' : ''} trouvé{filteredEvents.length > 1 ? 's' : ''}
          </div>

          <div className="row">
            {filteredEvents.length > 0 ? (
              filteredEvents.slice(0, eventsToShow).map((event, index) => (
                <motion.div
                  key={event.id}
                  className="col-lg-6 mb-4"
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: (index % 4) * 0.1 }}
                >
                  <div className="event-card">
                    <div className="event-date-block">
                      <div className="event-month">{event.date.split(' ')[1]}</div>
                      <div className="event-day">{event.date.split(' ')[0]}</div>
                    </div>
                    <div className="event-content">
                      <div className="event-type">{event.type}</div>
                      <h3 className="event-title">{event.title}</h3>
                      <div className="event-details">
                        <div className="event-detail">
                          <FaClock className="event-icon" />
                          {event.time}
                        </div>
                        <div className="event-detail">
                          <FaMapMarkerAlt className="event-icon" />
                          {event.location}
                        </div>
                      </div>
                      <div className="event-actions">
                        <Link to={`/evenements/${event.id}`} className="btn-details">
                          Détails
                        </Link>
                        <a href={event.registrationLink} className="btn-register">
                          S'inscrire
                        </a>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))
            ) : (
              <div className="col-12">
                <div className="no-events-found">
                  <img
                    src="../assets/images/image24.png"
                    alt="Aucun événement trouvé"
                    className="no-events-image"
                  />
                  <h3>Aucun événement ne correspond à votre recherche</h3>
                  <p>Essayez de modifier vos critères de recherche ou consultez nos événements à venir.</p>
                  <button
                    className="btn-reset-filters"
                    onClick={() => {
                      setSearchTerm("");
                      setSelectedType("Tous");
                      setSelectedMonth("Tous");
                    }}
                  >
                    Réinitialiser les filtres
                  </button>
                </div>
              </div>
            )}
          </div>

          {eventsToShow < filteredEvents.length && (
            <div className="text-center mt-4 mb-5">
              <button className="load-more-btn" onClick={loadMoreEvents}>
                Voir plus d'événements
              </button>
            </div>
          )}
        </div>
      </section>

      {/* Section Abonnement aux Alertes Événements */}
      <section className="events-subscribe-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <motion.div
                className="subscribe-content"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
              >
                <h2 className="subscribe-title">Ne manquez aucun événement</h2>
                <p className="subscribe-desc">
                  Recevez des notifications personnalisées sur nos prochains événements,
                  formations et webinaires en fonction de vos centres d'intérêt.
                </p>
                <form onSubmit={handleSubmitSubscription} className="subscribe-form">
                  <div className="form-group">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Votre adresse email"
                      value={emailSubscription}
                      onChange={(e) => setEmailSubscription(e.target.value)}
                      required
                    />
                    <button type="submit" className="btn-subscribe">
                      S'abonner
                    </button>
                  </div>
                  <div className="form-check mt-3">
                    <input type="checkbox" className="form-check-input" id="privacyCheck" required />
                    <label className="form-check-label" htmlFor="privacyCheck">
                      J'accepte de recevoir des informations sur les événements CINEF-EC
                    </label>
                  </div>
                </form>
              </motion.div>
            </div>
            <div className="col-lg-6">
              <motion.div
                className="subscribe-image-container"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
              >
                <img
                  src="../assets/images/image1.png"
                  alt="Restez informé"
                  className="subscribe-image"
                />
                <div className="notification-preview">
                  <div className="notification-header">
                    <div className="notification-app">CINEF-EC Events</div>
                    <div className="notification-time">maintenant</div>
                  </div>
                  <div className="notification-content">
                    <div className="notification-title">Nouveau webinaire disponible!</div>
                    <div className="notification-message">
                      "Optimisation fiscale pour PME" - Inscription ouverte
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      <style>{`
        /* STYLES GLOBAUX */
        :root {
          --primary-color: #dc3545;
          --secondary-color: #198754;
          --primary-gradient: linear-gradient(135deg, #dc3545 0%, #1a3c61 100%);
          --secondary-gradient: linear-gradient(to right, #dc3545, #198754);
          --dark-color: #1a3c61;
          --light-color: #f8f9fa;
          --text-color: #333;
          --grey-color: #6c757d;
          --border-radius: 10px;
          --box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
          --transition: all 0.3s ease;
        }

        .animate {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
        
        .text-gradient {
          background: linear-gradient(to right, #dc3545, #198754);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          color: transparent;
        }

        .highlight {
          color: #dc3545;
          position: relative;
        }

        .section-title {
          font-size: 32px;
          font-weight: bold;
          position: relative;
          display: inline-block;
          margin-bottom: 50px;
        }
        
        .section-title::after {
          content: '';
          position: absolute;
          bottom: -15px;
          left: 0;
          width: 60px;
          height: 4px;
          background: linear-gradient(to right, #dc3545, #198754);
          border-radius: 2px;
        }

        /* HERO SECTION */
        .events-hero-section {
          position: relative;
          background: linear-gradient(135deg, #dc3545 0%, #198754 100%);
          color: white;
          padding: 120px 0 80px;
          overflow: hidden;
        }

        .events-hero-content {
          position: relative;
          z-index: 2;
        }

        .events-hero-text {
          padding-bottom: 30px;
        }

        .events-hero-title {
          display: flex;
          flex-direction: column;
          margin-bottom: 25px;
        }

        .events-hero-subtitle {
          font-size: 18px;
          font-weight: 500;
          text-transform: uppercase;
          letter-spacing: 2px;
          margin-bottom: 15px;
          color: rgba(255, 255, 255, 0.8);
        }

        .events-main-title {
          font-size: 48px;
          font-weight: 800;
          line-height: 1.1;
        }

        .events-hero-desc {
          font-size: 18px;
          margin-bottom: 30px;
          opacity: 0.9;
          max-width: 90%;
        }

        .events-counter {
          display: flex;
          margin-top: 30px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: var(--border-radius);
          padding: 20px;
          backdrop-filter: blur(10px);
        }

        .counter-item {
          flex: 1;
          text-align: center;
          padding: 0 15px;
          border-right: 1px solid rgba(255, 255, 255, 0.2);
        }

        .counter-item:last-child {
          border-right: none;
        }

        .counter-number {
          font-size: 36px;
          font-weight: 700;
          margin-bottom: 5px;
        }

        .counter-label {
          font-size: 14px;
          opacity: 0.8;
        }

        .events-hero-image {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .wave-divider {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          overflow: hidden;
          line-height: 0;
        }

        .wave-divider svg {
          position: relative;
          display: block;
          width: calc(100% + 1.3px);
          height: 80px;
        }

        .wave-divider .shape-fill {
          fill: #f8f9fa;
        }

        /* CALENDRIER ANIMÉ */
        .events-calendar {
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          border-radius: var(--border-radius);
          overflow: hidden;
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
          width: 100%;
          max-width: 400px;
          margin: 0 auto;
        }

        .calendar-header {
          background: rgba(255, 255, 255, 0.2);
          padding: 15px;
          text-align: center;
        }

        .month-display {
          font-size: 22px;
          font-weight: 700;
        }

        .calendar-body {
          padding: 15px;
        }

        .week-days {
          display: grid;
          grid-template-columns: repeat(7, 1fr);
          text-align: center;
          font-weight: 600;
          margin-bottom: 10px;
          font-size: 12px;
        }

        .days-grid {
          display: grid;
          grid-template-columns: repeat(7, 1fr);
          gap: 8px;
        }

        .day-cell {
          aspect-ratio: 1/1;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          cursor: pointer;
          transition: var(--transition);
          font-size: 14px;
          background: rgba(255, 255, 255, 0.05);
        }

        .day-cell:hover {
          background: rgba(255, 255, 255, 0.2);
        }

        .day-cell.has-event {
          background: rgba(220, 53, 69, 0.5);
        }

        .calendar-footer {
          padding: 10px 15px;
          background: rgba(255, 255, 255, 0.05);
        }

        .legend {
          display: flex;
          justify-content: center;
          gap: 15px;
        }

        .legend-item {
          display: flex;
          align-items: center;
          font-size: 12px;
        }

        .legend-dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.05);
          margin-right: 5px;
        }

        .legend-dot.has-event {
          background: rgba(220, 53, 69, 0.5);
        }

        /* FEATURED EVENTS SECTION */
        .featured-events-section {
          background-color: #f8f9fa;
          padding: 80px 0;
        }

        .featured-event-card {
          background: white;
          border-radius: var(--border-radius);
          box-shadow: var(--box-shadow);
          overflow: hidden;
          transition: var(--transition);
          height: 100%;
        }

        .featured-event-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1);
        }

        .featured-event-image {
          position: relative;
          width: 100%;
          height: 200px;
          overflow: hidden;
        }

        .featured-event-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .featured-event-card:hover .featured-event-image img {
          transform: scale(1.05);
        }

        .event-type-badge {
          position: absolute;
          top: 15px;
          right: 15px;
          background: #dc3545;
          color: white;
          padding: 5px 15px;
          border-radius: 30px;
          font-size: 12px;
          font-weight: 600;
          z-index: 2;
        }

        .featured-event-content {
          padding: 25px;
        }

        .event-meta {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          margin-bottom: 15px;
          font-size: 14px;
          color: var(--grey-color);
        }

        .event-date-time, .event-location {
          display: flex;
          align-items: center;
          margin-bottom: 5px;
        }

        .icon {
          margin-right: 5px;
        }

        .separator {
          margin: 0 5px;
        }

        .event-title {
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 15px;
          color: var(--dark-color);
        }

        .event-description {
          color: var(--grey-color);
          font-size: 15px;
          margin-bottom: 20px;
          line-height: 1.6;
        }

        .event-speakers {
          margin-bottom: 20px;
        }

        .event-speaker {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
        }

        .speaker-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 12px;
          border: 2px solid #f8f9fa;
        }

        .speaker-avatar img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .speaker-name {
          font-weight: 600;
          font-size: 15px;
          color: var(--dark-color);
        }

        .speaker-role {
          font-size: 13px;
          color: var(--grey-color);
        }

        .event-actions {
          display: flex;
          justify-content: space-between;
          margin-top: 20px;
        }

        .btn-details, .btn-register {
          display: inline-block;
          padding: 10px 20px;
          border-radius: 30px;
          font-weight: 600;
          font-size: 14px;
          transition: var(--transition);
          text-align: center;
        }

        .btn-details {
          background: transparent;
          border: 1px solid var(--dark-color);
          color: var(--dark-color);
        }

        .btn-details:hover {
          background: var(--dark-color);
          color: white;
          text-decoration: none;
        }

        .btn-register {
          background: linear-gradient(to right, #dc3545, #198754);
          color: white;
          border: none;
        }

        .btn-register:hover {
          opacity: 0.9;
          transform: translateY(-2px);
          text-decoration: none;
          color: white;
        }

        /* SEARCH AND FILTERS SECTION */
        .events-filter-section {
          padding: 40px 0;
          background-color: white;
        }

        .search-filter-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 20px;
        }

        .search-container {
          position: relative;
          flex: 1;
          max-width: 500px;
        }

        .search-icon {
          position: absolute;
          left: 15px;
          top: 50%;
          transform: translateY(-50%);
          color: var(--grey-color);
        }

        .search-input {
          width: 100%;
          padding: 12px 15px 12px 45px;
          border: 1px solid #e9ecef;
          border-radius: 30px;
          transition: var(--transition);
          font-size: 15px;
        }

        .search-input:focus {
          border-color: var(--primary-color);
          box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.2);
          outline: none;
        }

        .toggle-filters-btn {
          background: var(--light-color);
          border: none;
          padding: 12px 20px;
          border-radius: 30px;
          font-weight: 600;
          font-size: 14px;
          display: flex;
          align-items: center;
          gap: 8px;
          cursor: pointer;
          transition: var(--transition);
        }

        .toggle-filters-btn:hover {
          background: #e9ecef;
        }

        .filters-container {
          background: #f8f9fa;
          padding: 20px;
          border-radius: var(--border-radius);
          margin-bottom: 30px;
        }

        .filter-group {
          margin-bottom: 20px;
        }

        .filter-title {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 15px;
          color: var(--dark-color);
        }

        .filter-options {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
        }

        .filter-option {
          background: white;
          border: 1px solid #e9ecef;
          padding: 8px 15px;
          border-radius: 20px;
          font-size: 14px;
          cursor: pointer;
          transition: var(--transition);
        }

        .filter-option:hover {
          border-color: var(--primary-color);
        }

        .filter-option.active {
          background: var(--primary-color);
          color: white;
          border-color: var(--primary-color);
        }

        /* EVENTS LIST SECTION */
        .events-list-section {
          padding: 40px 0 80px;
          background-color: #f8f9fa;
        }

        .results-count {
          font-size: 16px;
          color: var(--grey-color);
          font-weight: 500;
        }

        .event-card {
          display: flex;
          background: white;
          border-radius: var(--border-radius);
          overflow: hidden;
          box-shadow: var(--box-shadow);
          transition: var(--transition);
          height: 100%;
        }

        .event-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
        }

        .event-date-block {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #dc3545 0%, #1a3c61 100%);
          color: white;
          padding: 15px;
          min-width: 90px;
        }

        .event-month {
          font-size: 14px;
          text-transform: uppercase;
          font-weight: 600;
        }

        .event-day {
          font-size: 28px;
          font-weight: 700;
          line-height: 1;
        }

        .event-content {
          padding: 20px;
          flex: 1;
        }

        .event-type {
          font-size: 13px;
          color: var(--primary-color);
          font-weight: 600;
          margin-bottom: 8px;
        }

        .event-details {
          display: flex;
          flex-wrap: wrap;
          margin-top: 15px;
          gap: 15px;
          font-size: 14px;
          color: var(--grey-color);
        }

        .event-detail {
          display: flex;
          align-items: center;
        }

        .event-icon {
          margin-right: 6px;
        }

        .load-more-btn {
          background: transparent;
          border: 2px solid var(--primary-color);
          color: var(--primary-color);
          padding: 12px 30px;
          border-radius: 30px;
          font-weight: 600;
          font-size: 15px;
          transition: var(--transition);
          cursor: pointer;
        }

        .load-more-btn:hover {
          background: var(--primary-color);
          color: white;
        }

        .no-events-found {
          text-align: center;
          padding: 50px 20px;
        }

        .no-events-image {
          width: 150px;
          margin-bottom: 20px;
        }

        .btn-reset-filters {
          background: var(--primary-color);
          color: white;
          border: none;
          padding: 10px 25px;
          border-radius: 30px;
          font-weight: 600;
          font-size: 15px;
          margin-top: 20px;
          cursor: pointer;
          transition: var(--transition);
        }

        .btn-reset-filters:hover {
          opacity: 0.9;
        }

        /* SUBSCRIBE SECTION */
        .events-subscribe-section {
          padding: 80px 0;
          background-color: white;
        }

        .subscribe-title {
          font-size: 32px;
          font-weight: 700;
          margin-bottom: 20px;
          color: var(--dark-color);
        }

        .subscribe-desc {
          font-size: 16px;
          color: var(--grey-color);
          margin-bottom: 30px;
          line-height: 1.6;
        }

        .subscribe-form {
          max-width: 500px;
        }

        .form-group {
          position: relative;
        }

        .form-control {
          padding: 15px 20px;
          border-radius: 30px;
          border: 1px solid #e9ecef;
          font-size: 15px;
          width: 100%;
          padding-right: 150px;
        }

        .form-control:focus {
          border-color: var(--primary-color);
          box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.2);
          outline: none;
        }

        .btn-subscribe {
          position: absolute;
          right: 5px;
          top: 5px;
          bottom: 5px;
          background: linear-gradient(to right, #dc3545, #198754);
          color: white;
          border: none;
          border-radius: 30px;
          padding: 0 25px;
          font-weight: 600;
          font-size: 14px;
          cursor: pointer;
          transition: var(--transition);
        }

        .btn-subscribe:hover {
          opacity: 0.9;
        }

        .form-check-label {
          font-size: 14px;
          color: var(--grey-color);
        }

        .subscribe-image-container {
          position: relative;
        }

        .subscribe-image {
          width: 100%;
          border-radius: var(--border-radius);
          box-shadow: var(--box-shadow);
        }

        .notification-preview {
          position: absolute;
          top: 30px;
          right: -20px;
          background: white;
          border-radius: 12px;
          padding: 15px;
          width: 300px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
          animation: float 3s ease-in-out infinite;
        }

        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-15px); }
          100% { transform: translateY(0px); }
        }

        .notification-header {
          display: flex;
          justify-content: space-between;
          margin-bottom: 8px;
        }

        .notification-app {
          font-weight: 600;
          font-size: 14px;
        }

        .notification-time {
          font-size: 12px;
          color: var(--grey-color);
        }

        .notification-title {
          font-weight: 600;
          font-size: 15px;
          margin-bottom: 5px;
        }

        .notification-message {
          font-size: 14px;
          color: var(--grey-color);
        }

        /* RESPONSIVE STYLES */
        @media (max-width: 1200px) {
          .notification-preview {
            right: 0;
          }
        }

        @media (max-width: 992px) {
          .events-main-title {
            font-size: 40px;
          }
          
          .subscribe-image-container {
            margin-top: 40px;
          }
          
          .notification-preview {
            position: relative;
            top: -60px;
            right: 0;
            margin: 0 auto;
          }
        }

        @media (max-width: 768px) {
          .events-hero-section {
            padding: 80px 0 60px;
          }
          
          .events-hero-text {
            text-align: center;
            margin-bottom: 40px;
          }
          
          .events-hero-desc {
            max-width: 100%;
          }
          
          .events-counter {
            justify-content: center;
          }
          
          .counter-item {
            padding: 0 10px;
          }
          
          .counter-number {
            font-size: 30px;
          }
          
          .section-title {
            text-align: center;
            display: block;
          }
          
          .section-title::after {
            left: 50%;
            transform: translateX(-50%);
          }
          
          .featured-event-card, .event-card {
            margin-bottom: 20px;
          }
          
          .search-filter-container {
            flex-direction: column;
            gap: 15px;
          }
          
          .search-container {
            width: 100%;
            max-width: none;
          }
          
          .toggle-filters-btn {
            width: 100%;
            justify-content: center;
          }
          
          .event-actions {
            flex-direction: column;
            gap: 10px;
          }
          
          .btn-details, .btn-register {
            width: 100%;
          }
          
          .subscribe-content {
            text-align: center;
          }
        }

        @media (max-width: 576px) {
          .events-main-title {
            font-size: 32px;
          }
          
          .counter-item {
            flex: none;
            width: 33.33%;
          }
          
          .event-date-block {
            min-width: 70px;
            padding: 10px;
          }
          
          .event-day {
            font-size: 24px;
          }
          
          .notification-preview {
            width: 90%;
          }
        }
       `}
      </style>
    </ >


  );
};

export default Evenements;

